import request from '@/utils/request'

// -------------------- /pay/member/ --------------------

// 当月收支统计
export function currentMonthOutIn() {
    return request({
        url: '/pay/member/capital/member/month/outIn',
        method: 'get'
    })
}

// 获取会员资金详情
export function getFundDetail() {
    return request({
        url: '/pay/member/capital',
        method: 'get'
    })
}

// -------------------- /pay/sign/ --------------------

// 查询是否与银行签约
export function isUserSignBank(id) {
    return request({
        url: '/pay/sign/flag/' + id,
        method: 'get'
    })
}

// 签约
export function bankSign(data) {
    return request({
        url: '/pay/sign',
        method: 'post',
        data
    })
}

// 解约
export function relieveSign(verifyCode) {
    return request({
        url: `/pay/sign/unbind/${verifyCode}`,
        method: 'put',
    })
}

// 会员是否签约
export function getSignFlag(query) {
    return request({
        url: '/pay/sign/check',
        method: 'get'
    })
}

// 变更签约
export function updateSign(data) {
    return request({
        url: '/pay/sign',
        method: 'put',
        data
    })
}

// -------------------- /pay/logs/ --------------------

// 获取收支流水
export function getLogsList(query) {
    return request({
        url: '/pay/logs/list',
        method: 'get',
        params: query
    })
}

// 获取资金流水支付状态字典
export function getLogsStatus() {
    return request({
        url: '/pay/logs/statuses',
        method: 'get',
    })
}

// 获取出入金流水
export function getOutinMoneyList(query) {
    return request({
        url: '/pay/logs/outin/money/list',
        method: 'get',
        params: query
    })
}

// 获取平台保证金交易流水
export function getDepositList(query) {
    return request({
        url: '/pay/logs/deposit/list',
        method: 'get',
        params: query
    })
}

// -------------------- /pay/buss/ --------------------

// 获取所有的业务类型列表
export function getTypeList() {
    return request({
        url: '/pay/buss/type/list',
        method: 'get'
    })
}

// 获取出入金业务类型列表
export function getOutandInTypeList() {
    return request({
        url: '/pay/buss/type/outandin',
        method: 'get'
    })
}

// -------------------- /pay/bank/ --------------------

// 下载回执单
export function downloadReceipt(query) {
    return request({
        url: '/pay/bank/pay/download/report',
        method: 'get',
        params: query
    })
}

// 交易账号出金
export function outCash(data) {
    return request({
        url: '/pay/bank/pay/out/money',
        method: 'post',
        data
    })
}

// 冻结平台保证金（充值）
export function freezePlatformDeposit(data) {
    return request({
        url: '/pay/bank/pay/freeze/platform/deposit',
        method: 'post',
        data
    })
}

// 获取绑卡信息
export function getCardDetail() {
    return request({
        url: '/pay/bank/pay/bind/card/detail',
        method: 'get'
    })
}

// 获取短信验证码
export function getPayVerifyCode(phone) {
    return request({
        url: '/pay/bank/pay/send/' + phone,
        method: 'get',
    })
}

// 交易账号出金客户手续费计算
export function calcOutMoneyFee(query) {
    return request({
        url: '/pay/bank/pay/out/cusPayMoney/',
        method: 'get',
        params: query
    })
}

// 提取平台保证金
export function thawDeposit(query) {
    return request({
        url: '/pay/bank/pay/platform/deposit/thaw',
        method: 'get',
        params: query
    })
}

// -------------------- /pay/deposit/ --------------------

// 获取会员保证金详情
export function getDepositDetail() {
    return request({
        url: '/pay/deposit/member',
        method: 'get'
    })
}

// -------------------- /pay/bank/manage/ --------------------

// 查询平台入住银行列表
export function getBankList(query) {
    return request({
        url: '/pay/bank/manage/list',
        method: 'get'
    })
}

// 获取所有的银行列表
export function getBankAllList(query) {
    return request({
        url: '/pay/bank/manage/all',
        method: 'get',
        params: query
    })
}

// -------------------- /pay/bigoutlogs/ --------------------

// 大额出金流水
export function bigSumBill(params) {
    return request({
        url: '/pay/bigoutlogs/list',
        method: 'get',
        params
    })
}

// 大额出金手机结果查询
export function bigSumQuery(serialNum) {
    return request({
        url: '/pay/bigoutlogs/self/confirm/' + serialNum,
        method: 'get'
    })
}

// 大额出金明细
export function bigSumDetail(id) {
    return request({
        url: '/pay/bigoutlogs/' + id,
        method: 'get'
    })
}
